import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
  title?: string;
}

// 🎯 Single Responsibility Principle (SRP)
// Este componente SOLO maneja estados de error
export const ErrorState = ({
  error,
  onRetry,
  className = 'h-64',
  title = 'Error al cargar impresoras',
}: ErrorStateProps) => {
  return (
    <div className={'flex items-center justify-center ' + className}>
      <div className="text-center">
        {/* Error Icon - Icono de error */}
        <div className="mb-4">
          <FontAwesomeIcon icon={faExclamationTriangle} className="w-12 h-12 text-warning" />
        </div>

        {/* Error Title - Título del error */}
        <h3 className="text-lg font-semibold text-title mb-2">{title}</h3>

        {/* Error Message - Mensaje del error */}
        <p className="text-subtext mb-4">{error.message}</p>

        {/* Retry Button - Botón de reintentar */}
        <Button onClick={onRetry} variant="primary" data-testid="retry-button" className="mx-auto">
          Reintentar
        </Button>
      </div>
    </div>
  );
};
